import { render, staticRenderFns } from "./ProvidersTable.vue?vue&type=template&id=0906e7e0&"
import script from "./ProvidersTable.vue?vue&type=script&lang=ts&"
export * from "./ProvidersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports